import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { CircularProgress, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';

// local imports
import { AuthService, ProfileService, CommonService } from 'app/services';
import { useStateCallback } from 'app/hooks';
import { setUser, setUserRoles } from 'app/auth/store/userSlice';

function CallbackComponent() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useStateCallback(false);

  useEffect(() => {
    const login = async () => {
      setLoading(true, async () => {
        try {
          // Get system user details
          const profileInfo = await ProfileService.getProfileDetail();
          const systemUserRoles = await CommonService.getSystemUserRoles();

          // ...and set them to redux store
          dispatch(setUser({ ...profileInfo?.data?.data }));
          dispatch(setUserRoles([...systemUserRoles?.data?.data]));

          history.push('/dashboard');
        } catch (err) {
          console.log('err ->', err);
        } finally {
          setLoading(false);
        }
      });
    };

    AuthService.signInRedirectCallback().then(user => {
      login();
    });

    // cleanup function
    return () => {
      setLoading(false);
    };
  }, [setLoading, dispatch, history]);

  return (
    <>
      <div id="splash-screen" className="flex flex-col justify-center items-center">
        <div className="logo">
          <img src="assets/images/logos/turp-01.svg" alt="turp_logo" />
        </div>
        <div className="flex flex-col justify-center items-center mt-32 space-y-28 mr-64">
          <Typography variant="h5" className="font-semibold text-gray-700 tracking-widest">
            Giriş Yapılıyor...
          </Typography>
          <CircularProgress thickness={4} size={80} className="text-pink-400" />
        </div>
      </div>
    </>
  );
}

export default CallbackComponent;
